import { withSeparator, withToman } from '@rahtab/system/lib/tools/string';
import {
  Button,
  ButtonBase,
  Card,
  CardCaption,
  CardContainer,
  Colors,
  getRadius,
  getSpacing,
  Text,
  TextInput,
  TextView,
} from '@rahtab/ui';
import ChevronLeftIcon from '@rahtab/ui/dist/icons/ChevronLeftIcon';
import React, { VFC, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Order } from '../../hooks/useOrdersHistory';
import OrderStatus from './OrderStatus';
import useSetMaxOrderAmount from '../../hooks/useSetMaxOrderAmount';

const OrderItem: VFC<OrderItemProps> = ({
  orderDate,
  orderId,
  assignFinalCode,
  status,
  statusCode,
  totalPrice,
  orderCount,
  supplierName,
  measureUnit,
  orderCode,
  maxOrderAmount = '',
  viewerCanSetMaxOrderAmount,
}) => {
  const [amount, setAmount] = useState(maxOrderAmount);
  const [setMaxOrderAmount, { loading }] = useSetMaxOrderAmount({ orderId: orderCode, amount });
  return (
    <Card style={styles.container}>
      <ButtonBase disabled={statusCode !== '2'} screenName={'ReceivedLoad'} params={{ assignFinalCode }}>
        <CardCaption height="small" style={styles.caption}>
          <Text margin="none" color="description">
            شناسه:
            <Text margin="none"> {orderId}</Text>
          </Text>
          <Text margin="none">{orderDate}</Text>
        </CardCaption>
        <CardContainer>
          <View style={styles.nameStatusView}>
            <Text margin="none" color="description">
              فروشنده:{' '}
              <Text margin="none" color="primary" variant="cardTitle">
                {supplierName}
              </Text>
            </Text>
            <OrderStatus status={status} statusCode={statusCode} />
          </View>

          <Text color="description">
            مقدار:
            <Text>
              {' '}
              {withSeparator(orderCount)} {measureUnit}
            </Text>
          </Text>
          <Text margin={!viewerCanSetMaxOrderAmount ? 'none' : 'default'} color="description">
            مبلغ:
            <Text margin={!viewerCanSetMaxOrderAmount ? 'none' : 'default'}> {withToman(totalPrice)}</Text>
          </Text>
          {viewerCanSetMaxOrderAmount ? (
            <>
              <Text style={styles.textCenter}>
                سفارشات پس از مشخص شدن مقدار دقیق کشتار، تغییر خواهند کرد. شما می‌توانید حداکثر قابل افزایش سفارش خود را
                در بازه حداقل ۱۰٪ افزایش الی حداکثر سقف ظرفیتی فروشگاه مشخص نمایید.
              </Text>
              <View style={styles.inputUnitView}>
                <TextInput
                  label="حداکثر مقدار قابل تحویل"
                  placeholder="حداکثر مقدار قابل تحویل را وارد کنید."
                  keyboardType="numeric"
                  style={styles.input}
                  value={amount}
                  onChangeText={setAmount}
                  editable={!loading}
                />
                <TextView
                  marginBottom={0}
                  textContainerStyle={styles.justifyCenter}
                  style={styles.unit}
                  value={measureUnit}
                />
              </View>
              <Button
                text="ثبت حداکثر مقدار قابل تحویل"
                color="primary"
                onPress={() => setMaxOrderAmount()}
                disabled={loading}
              />
            </>
          ) : null}
        </CardContainer>
        {statusCode === '2' && (
          <CardCaption>
            <View style={styles.caption}>
              <Text color="primary" margin="none">
                مشاهده بار دریافتی
              </Text>
              <ChevronLeftIcon stroke={Colors.primary} />
            </View>
          </CardCaption>
        )}
      </ButtonBase>
    </Card>
  );
};

export default OrderItem;

const styles = StyleSheet.create({
  container: {
    marginHorizontal: getSpacing(),
    marginVertical: getSpacing(0.5),
  },
  caption: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  nameStatusView: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: getSpacing(),
  },
  imageView: {
    borderWidth: getSpacing('border'),
    borderRadius: getRadius(),
    marginRight: getSpacing(),
    borderColor: Colors.border,
    overflow: 'hidden',
  },
  imageDetailsView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputUnitView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  unit: {
    width: 80,
    marginLeft: getSpacing(),
    marginBottom: getSpacing(),
  },
  input: {
    flex: 4,
  },
  justifyCenter: {
    justifyContent: 'center',
  },
  textCenter: {
    textAlign: 'center',
  },
});

interface OrderItemProps extends Order {}
